import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  Label,
  GroupItem,
  EmptyItem,
} from "devextreme-react/form";
import NumberBox from "devextreme-react/number-box";
import UserInfo from "../../UserInfo";
import uiInfo from "../../ui-info";
import {
  criarLogradouroDs,
  criarBairroDs,
  criarImovelBciDs,
  inserirOuAtualizar,
} from "../../DataSources";
import LogradourosBox from "../LogradourosBox";
import BairrosBox from "../BairrosBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { ScrollView, Button } from "devextreme-react";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  numeroBci: undefined,
  codAcesso: undefined,
  distrito: undefined,
  setor: undefined,
  quadra: undefined,
  lote: undefined,
  unidade: undefined,
  comando: undefined,
  equipe: undefined,
  sequencia: undefined,
  codSeguimento: undefined,
  codLogradouro: undefined,
  logradouroImovel: undefined,
  numeroImovel: undefined,
  complementoOuLoteamentoImovel: undefined,
  codBairroImovel: undefined,
  bairroImovel: undefined,
  nomeOuRazaoSocial: undefined,
  cpf: undefined,
  cnpj: undefined,
  apelido: undefined,
  codLogradouroProprietario: undefined,
  logradouroProprietario: undefined,
  numeroProprietario: undefined,
  complementoProprietario: undefined,
  codBairroProprietario: undefined,
  bairroProprietario: undefined,
  municipioProprietario: undefined,
  cepProprietario: undefined,
  telefoneProprietario: undefined,
  largura: undefined,
  comprimento: undefined,
  areaTotal: undefined,
  areaPrivada: undefined,
  areaComum: undefined,
  afastamentoFrontal: undefined,
  numeroPavimentos: undefined,
  numeroFrentes: undefined,
  quantidadeWC: undefined,
  coletaLixo: undefined,
  numeroUnidades: undefined,
  varricao: undefined,
  medidaPasseio: undefined,
  quantidadeCozinhas: undefined,
  arvoresPasseio: undefined,
  quantidadeQuartos: undefined,
  isentoIptu: undefined,
  quantidadeSalas: undefined,
  phoneMask: "(00) 0000-0000",
};

export default class ImovelBciForm extends React.Component {
  constructor() {
    super();
    this.state = { ...(_cadastroCorrente || template) };
    this.imovelBciDs = criarImovelBciDs();

    this.comandoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "Inclusão" },
        { id: 1, descricao: "Alteração" },
        { id: 2, descricao: "Cancelamento" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.bairrosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "Escolher...",
      dataSource: criarBairroDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.renderCartografia = this.renderCartografia.bind(this);
    this.onLogradouroSelecionadoPesq =
      this.onLogradouroSelecionadoPesq.bind(this);
    this.onLogradouroChange = this.onLogradouroChange.bind(this);

    this.onBairroSelecionadoPesq = this.onBairroSelecionadoPesq.bind(this);
    this.onBairroChange = this.onBairroChange.bind(this);

    this.handlePhoneMask = this.handlePhoneMask.bind(this);
    this.handleAreaTotal = this.handleAreaTotal.bind(this);

    this.logradourosBoxRef = React.createRef();
    this.bairroBoxRef = React.createRef();

    this.ok = this.ok.bind(this);
    this.cancelando = this.cancelando.bind(this);
  }

  renderCartografia() {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div style={{ width: "15%" }} className="dx-field-item-label-text">
            Dis
          </div>
          <div style={{ width: "15%" }} className="dx-field-item-label-text">
            Set
          </div>
          <div style={{ width: "25%" }} className="dx-field-item-label-text">
            Quadra
          </div>
          <div style={{ width: "20%" }} className="dx-field-item-label-text">
            Lote
          </div>
          <div style={{ width: "25%" }} className="dx-field-item-label-text">
            Un.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <NumberBox
            value={this.state.distrito}
            onValueChanged={(e) => this.setState({ distrito: e.value })}
            width={"15%"}
            format={uiInfo.formatoNumerico.inteiroSemPonto}
          />

          <NumberBox
            value={this.state.setor}
            onValueChanged={(e) => this.setState({ setor: e.value })}
            format={uiInfo.formatoNumerico.inteiroSemPonto}
            width={"15%"}
          />
          <NumberBox
            value={this.state.quadra}
            onValueChanged={(e) => this.setState({ quadra: e.value })}
            format={uiInfo.formatoNumerico.inteiroSemPonto}
            width={"25%"}
          />
          <NumberBox
            value={this.state.lote}
            onValueChanged={(e) => this.setState({ lote: e.value })}
            format={uiInfo.formatoNumerico.inteiroSemPonto}
            width={"20%"}
          />
          <NumberBox
            value={this.state.unidade}
            onValueChanged={(e) => this.setState({ unidade: e.value })}
            width={"25%"}
            format={uiInfo.formatoNumerico.inteiroSemPonto}
          />
        </div>
      </div>
    );
  }

  onLogradouroSelecionadoPesq(e, tipo) {
    let data = {
      value: e.row.data.sequencial,
    };
    this.onLogradouroChange(data, tipo);
  }

  onLogradouroChange(e, tipo) {
    criarLogradouroDs()
      .load({ filter: ["sequencial", "=", e.value] })
      .then((response) => {
        if (
          response !== null &&
          response !== undefined &&
          response.length > 0
        ) {
          if (tipo === "proprietario") {
            this.setState({
              codLogradouroProprietario: e.value.toString(),
              logradouroProprietario: response[0].nomeCompleto,
              exibirPesquisaLogradouroProprietario: false,
            });
          } else {
            this.setState({
              codLogradouro: e.value.toString(),
              logradouroImovel: response[0].nomeCompleto,
              exibirPesquisaLogradouro: false,
            });
          }
        }
      });
  }

  onBairroSelecionadoPesq(e, tipo) {
    let data = {
      value: e.row.data.sequencial,
    };
    this.onBairroChange(data, tipo);
  }

  onBairroChange(e, tipo) {
    criarBairroDs()
      .load({ filter: ["sequencial", "=", e.value] })
      .then((response) => {
        if (
          response !== null &&
          response !== undefined &&
          response.length > 0
        ) {
          if (tipo === "proprietario") {
            this.setState({
              codBairroProprietario: e.value.toString(),
              bairroProprietario: response[0].descricao,
              exibirPesquisaBairroProprietario: false,
            });
          } else {
            this.setState({
              codBairroImovel: e.value.toString(),
              bairroImovel: response[0].descricao,
              exibirPesquisaBairro: false,
            });
          }
        }
      });
  }

  handlePhoneMask(e) {
    var value = e.event.target.value.replace(/\D/g, "");
    if (value.length === 10) {
      this.setState({
        phoneMask: "(00) 00000-0000",
        telefoneProprietario: value,
      });
    }
    if (value.length < 10 && this.state.phoneMask !== "(00) 0000-0000") {
      this.setState({
        phoneMask: "(00) 0000-0000",
        telefoneProprietario: value,
      });
    }
  }

  handleAreaTotal(largura, comprimento) {
    let width = largura ? largura : this.state.largura || 0;
    let height = comprimento ? comprimento : this.state.comprimento || 0;
    this.setState({ areaTotal: width * height });
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.imovelBciDs, entidade)
      .then(
        function (response) {
          console.log(response);
          notify("Imóvel BCI cadastrado com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          this.props.history.push("/imovel-bci/editar/fatores/" + response.id);
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
    _cadastroCorrente = undefined;
    _cancelando = true;
  }

  cancelando() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    this.props.history.push("/imovel-bci");
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.imovelBciDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data === undefined) {
              notify("Imóvel BCI não encontrado.", "error");
              this.props.history.push("/imovel-bci");
            }
            console.log(data);
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button className="botaoImovel" icon="home" text="Imóvel" />
            <Button
              className="botaoImovel"
              icon="chart"
              text="Fatores Corretivos"
              width={200}
              onClick={() =>
                this.props.history.push("fatores/" + this.props.match.params.id)
              }
              disabled={this.props.match.params.id === undefined}
            />
          </div>
          <Form colCount={3} formData={this.state} labelLocation="top">
            <GroupItem caption="DADOS GERAIS" colSpan={3} colCount={3}>
              <SimpleItem dataField="numeroBci" colSpan={1}>
                <Label text="Número BCI" />
              </SimpleItem>
              <SimpleItem dataField="codAcesso" colSpan={1}>
                <Label text="Código de acesso" />
              </SimpleItem>
              <SimpleItem
                dataField="comando"
                editorType={"dxLookup"}
                editorOptions={this.comandoOptions}
                colSpan={1}
              >
                <Label text="Comando" />
              </SimpleItem>
              <SimpleItem
                render={this.renderCartografia}
                showTitle={false}
                colSpan={2}
              >
                <Label visible={false} />
              </SimpleItem>
              <SimpleItem dataField="sequencia" colSpan={1}>
                <Label text="Sequência" />
              </SimpleItem>
              <SimpleItem dataField="equipe" colSpan={2}>
                <Label text="Equipe" />
              </SimpleItem>
              <SimpleItem dataField="codSeguimento" colSpan={1}>
                <Label text="Código de segmento" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="ENDEREÇO" colSpan={3} colCount={5}>
              <SimpleItem
                dataField="codLogradouro"
                editorType={"dxNumberBox"}
                editorOptions={{
                  showClearButton: true,
                  value:
                    this.state.codLogradouro === undefined
                      ? null
                      : this.state.codLogradouro,
                  buttons: [
                    "clear",
                    {
                      name: "Pesquisar",
                      location: "after",
                      options: {
                        stylingMode: "text",
                        icon: "search",
                        onClick: () => {
                          this.setState({ exibirPesquisaLogradouro: true });
                        },
                      },
                    },
                  ],
                  onValueChanged: (e) => this.onLogradouroChange(e),
                }}
                colSpan={1}
              >
                <Label text="Cod. Logradouro" />
              </SimpleItem>
              <SimpleItem
                dataField={"logradouroImovel"}
                colSpan={3}
                editorOptions={{ hoverStateEnabled: false }}
              >
                <Label text="Logradouro" />
              </SimpleItem>

              <SimpleItem dataField={"numeroImovel"} colSpan={1}>
                <Label text="Nº" />
              </SimpleItem>

              <SimpleItem
                dataField={"complementoOuLoteamentoImovel"}
                colSpan={5}
              >
                <Label text="Complemento ou Loteamento" />
              </SimpleItem>

              <SimpleItem
                dataField="codBairroImovel"
                editorType={"dxNumberBox"}
                editorOptions={{
                  showClearButton: true,
                  value:
                    this.state.codBairroImovel === undefined
                      ? null
                      : this.state.codBairroImovel,
                  buttons: [
                    "clear",
                    {
                      name: "Pesquisar",
                      location: "after",
                      options: {
                        stylingMode: "text",
                        icon: "search",
                        onClick: () => {
                          this.setState({ exibirPesquisaBairro: true });
                        },
                      },
                    },
                  ],
                  onValueChanged: (e) => this.onBairroChange(e),
                }}
                colSpan={1}
              >
                <Label text="Cod. Bairro" />
              </SimpleItem>
              <SimpleItem
                dataField={"bairroImovel"}
                colSpan={3}
                editorOptions={{ hoverStateEnabled: false }}
              >
                <Label text="Bairro" />
              </SimpleItem>
            </GroupItem>

            <GroupItem caption="DADOS DO PROPRIETÁRIO" colSpan={3} colCount={3}>
              <SimpleItem dataField={"nomeOuRazaoSocial"} colSpan={3}>
                <Label text="Nome ou Razão Social" />
              </SimpleItem>
              <SimpleItem
                dataField={"cpf"}
                colSpan={1}
                editorType={"dxTextBox"}
                editorOptions={{ mask: "000.000.000-00" }}
              >
                <Label text="CPF" />
              </SimpleItem>
              <SimpleItem
                dataField={"cnpj"}
                colSpan={1}
                editorType={"dxTextBox"}
                editorOptions={{ mask: "00.000.000\\\\0000-00" }}
              >
                <Label text="CNPJ" />
              </SimpleItem>
              <SimpleItem dataField={"apelido"} colSpan={1}>
                <Label text="Nome Social ou Nome Fantasia" />
              </SimpleItem>
            </GroupItem>

            <GroupItem
              caption="ENDEREÇO DO PROPRIETÁRIO"
              colSpan={3}
              colCount={5}
            >
              <SimpleItem
                dataField="codLogradouroProprietario"
                editorType={"dxNumberBox"}
                editorOptions={{
                  showClearButton: true,
                  value:
                    this.state.codLogradouroProprietario === undefined
                      ? null
                      : this.state.codLogradouroProprietario,
                  buttons: [
                    "clear",
                    {
                      name: "Pesquisar",
                      location: "after",
                      options: {
                        stylingMode: "text",
                        icon: "search",
                        onClick: () => {
                          this.setState({
                            exibirPesquisaLogradouroProprietario: true,
                          });
                        },
                      },
                    },
                  ],
                  onValueChanged: (e) =>
                    this.onLogradouroChange(e, "proprietario"),
                }}
                colSpan={1}
              >
                <Label text="Cod. Logradouro" />
              </SimpleItem>
              <SimpleItem
                dataField={"logradouroProprietario"}
                colSpan={3}
                editorOptions={{ hoverStateEnabled: false }}
              >
                <Label text="Logradouro" />
              </SimpleItem>

              <SimpleItem dataField={"numeroProprietario"} colSpan={1}>
                <Label text="Nº" />
              </SimpleItem>

              <SimpleItem dataField={"complementoProprietario"} colSpan={5}>
                <Label text="Complemento" />
              </SimpleItem>

              <SimpleItem
                dataField="codBairroProprietario"
                editorType={"dxNumberBox"}
                editorOptions={{
                  showClearButton: true,
                  value:
                    this.state.codBairroProprietario === undefined
                      ? null
                      : this.state.codBairroProprietario,
                  buttons: [
                    "clear",
                    {
                      name: "Pesquisar",
                      location: "after",
                      options: {
                        stylingMode: "text",
                        icon: "search",
                        onClick: () => {
                          this.setState({
                            exibirPesquisaBairroProprietario: true,
                          });
                        },
                      },
                    },
                  ],
                  onValueChanged: (e) => this.onBairroChange(e, "proprietario"),
                }}
                colSpan={1}
              >
                <Label text="Cod. Bairro" />
              </SimpleItem>
              <SimpleItem
                dataField={"bairroProprietario"}
                colSpan={3}
                editorOptions={{ hoverStateEnabled: false }}
              >
                <Label text="Bairro" />
              </SimpleItem>
              <SimpleItem
                dataField={"cepProprietario"}
                colSpan={1}
                editorType={"dxTextBox"}
                editorOptions={{ mask: "00000-000" }}
              >
                <Label text="CEP" />
              </SimpleItem>
              <SimpleItem dataField={"municipioProprietario"} colSpan={2}>
                <Label text="Município" />
              </SimpleItem>
              <SimpleItem
                dataField={"telefoneProprietario"}
                colSpan={1}
                editorType={"dxTextBox"}
                editorOptions={{
                  mask: this.state.phoneMask,
                  onKeyDown: this.handlePhoneMask,
                }}
              >
                <Label text="Telefone" />
              </SimpleItem>
            </GroupItem>
            <GroupItem
              caption="PROPRIEDADES DO IMÓVEL"
              colSpan={3}
              colCount={4}
            >
              <SimpleItem
                dataField={"largura"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                  onValueChanged: (e) =>
                    this.handleAreaTotal(e.value, undefined),
                }}
              >
                <Label text="Largura" />
              </SimpleItem>
              <SimpleItem
                dataField={"comprimento"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                  onValueChanged: (e) =>
                    this.handleAreaTotal(undefined, e.value),
                }}
              >
                <Label text="Comprimento" />
              </SimpleItem>
              <SimpleItem
                dataField={"areaTotal"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              >
                <Label text="Área Total" />
              </SimpleItem>
              <SimpleItem
                dataField={"areaPrivada"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              >
                <Label text="Área Privada" />
              </SimpleItem>
              <SimpleItem
                dataField={"areaComum"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              >
                <Label text="Área Comum" />
              </SimpleItem>
              <SimpleItem
                dataField={"afastamentoFrontal"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              >
                <Label text="Afastamento Frontal" />
              </SimpleItem>
              <SimpleItem
                dataField={"medidaPasseio"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              >
                <Label text="Medida Passeio" />
              </SimpleItem>
              <SimpleItem
                dataField={"arvoresPasseio"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Árvores no Passeio" />
              </SimpleItem>
              <SimpleItem
                dataField={"numeroPavimentos"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Número de Pavimentos" />
              </SimpleItem>
              <SimpleItem
                dataField={"numeroFrentes"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Número de Frentes" />
              </SimpleItem>
              <SimpleItem
                dataField={"quantidadeWC"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Quantidade de Banheiros" />
              </SimpleItem>
              <SimpleItem
                dataField={"numeroUnidades"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Número de Unidades" />
              </SimpleItem>
              <SimpleItem
                dataField={"quantidadeSalas"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Quantidade de Salas" />
              </SimpleItem>
              <SimpleItem
                dataField={"quantidadeCozinhas"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Quantidade de Cozinhas" />
              </SimpleItem>
              <SimpleItem
                dataField={"quantidadeQuartos"}
                colSpan={1}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Quantidade de Quartos" />
              </SimpleItem>
              <EmptyItem colSpan={1} />
              <SimpleItem
                dataField={"coletaLixo"}
                colSpan={1}
                editorType={"dxCheckBox"}
              >
                <Label text="Coleta de Lixo" />
              </SimpleItem>
              <SimpleItem
                dataField={"isentoIptu"}
                colSpan={1}
                editorType={"dxCheckBox"}
              >
                <Label text="Isento de Iptu" />
              </SimpleItem>
              <SimpleItem
                dataField={"varricao"}
                colSpan={1}
                editorType={"dxCheckBox"}
              >
                <Label text="Varrição" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              gap: "15px",
              justifyContent: "center",
            }}
          >
            <Button
              width={120}
              text="Salvar"
              type="success"
              onClick={this.ok}
            />
            <Button
              width={120}
              type={"danger"}
              text="Cancelar"
              onClick={this.cancelando}
            />
          </div>
        </div>
        <Popup
          visible={this.state.exibirPesquisaLogradouro}
          onHiding={() => this.setState({ exibirPesquisaLogradouro: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Logradouro"
        >
          <ScrollView showScrollbar={"onScroll"}>
            <LogradourosBox
              onSelecionado={(e) =>
                this.onLogradouroSelecionadoPesq(e, "imovel")
              }
              ref={this.logradourosBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ exibirPesquisaLogradouro: false }),
            }}
          ></ToolbarItem>
        </Popup>

        <Popup
          visible={this.state.exibirPesquisaLogradouroProprietario}
          onHiding={() =>
            this.setState({ exibirPesquisaLogradouroProprietario: false })
          }
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Logradouro"
        >
          <ScrollView showScrollbar={"onScroll"}>
            <LogradourosBox
              onSelecionado={(e) =>
                this.onLogradouroSelecionadoPesq(e, "proprietario")
              }
              ref={this.logradourosBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () =>
                this.setState({ exibirPesquisaLogradouroProprietario: false }),
            }}
          ></ToolbarItem>
        </Popup>

        <Popup
          visible={this.state.exibirPesquisaBairro}
          onHiding={() => this.setState({ exibirPesquisaBairro: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Bairro"
        >
          <ScrollView showScrollbar={"onScroll"}>
            <BairrosBox
              onSelecionado={this.onBairroSelecionadoPesq}
              ref={this.bairroBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ exibirPesquisaBairro: false }),
            }}
          ></ToolbarItem>
        </Popup>

        <Popup
          visible={this.state.exibirPesquisaBairroProprietario}
          onHiding={() =>
            this.setState({ exibirPesquisaBairroProprietario: false })
          }
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Bairro"
        >
          <ScrollView showScrollbar={"onScroll"}>
            <BairrosBox
              onSelecionado={(e) =>
                this.onBairroSelecionadoPesq(e, "proprietario")
              }
              ref={this.bairroBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () =>
                this.setState({ exibirPesquisaBairroProprietario: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }
}
